'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleDetailsController = function () {
  function VehicleDetailsController(lookupService, authService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, VehicleDetailsController);
    this.lookupService = lookupService;
    this.authService = authService;

    this.initializeLookups();

    this.panels = {
      extras: true
    };

    this.editLoad = false;

    this.defaultExtrasList = [];
  }

  (0, _createClass3.default)(VehicleDetailsController, [{
    key: 'initializeLookups',
    value: function initializeLookups() {
      var ctrl = this;

      this.lookupService.lookupAccessoryLookups(this.authService.authData.currentLocation.key).then(function (accessoryLookups) {
        ctrl.accessoryLookups = accessoryLookups;

        ctrl.vehicle.extras = (0, _lodash.map)(ctrl.defaultExtrasList, function (item) {
          return {
            key: item.key,
            value: ''
          };
        });

        ctrl.vehicle.accessories = (0, _lodash.map)(ctrl.accessoryLookups, function (item) {
          return {
            accessoryLookupId: item.accessoryLookupId,
            name: item.name,
            enabled: false
          };
        });
      });
    }
  }, {
    key: '$doCheck',
    value: function $doCheck() {
      var ctrl = this;

      if (!ctrl.editLoad && ctrl.vehicle && ctrl.vehicle.vehicleId) {
        var editAccessories = ctrl.vehicle.accessories;
        var newAccessories = (0, _lodash.map)(ctrl.accessoryLookups, function (item) {
          var matchingAccessory = (0, _lodash.find)(editAccessories, function (o) {
            return o.accessoryLookupId === item.accessoryLookupId;
          });
          var enabled = matchingAccessory ? matchingAccessory.enabled : false;

          return {
            accessoryLookupId: item.accessoryLookupId,
            name: item.name,
            enabled: enabled
          };
        });
        ctrl.vehicle.accessories = newAccessories;

        var missingElements = (0, _lodash.differenceBy)(this.defaultExtrasList, this.vehicle.extras, 'key');
        missingElements.map(function (item) {
          ctrl.vehicle.extras.push({
            key: item.key,
            value: ''
          });
        });

        this.editLoad = true;
      }
    }
  }, {
    key: 'addField',
    value: function addField() {
      if (this.tempField) {
        this.vehicle.extras.push({ key: this.tempField, value: '' });
        this.tempField = '';
      }
    }
  }]);
  return VehicleDetailsController;
}();

exports.default = VehicleDetailsController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleEdit/vehicleDetails/vehicleDetails.controller.js